// extracted by mini-css-extract-plugin
module.exports = {"sec1":"About2_sec1__31YlK","jiagoubox":"About2_jiagoubox__17yPV","title1":"About2_title1__gLP0d","sec2":"About2_sec2__3Dgdx","list":"About2_list__2H7Yg"};